import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import { Container, Grid } from "@mui/material";
import Breadcrums from "components/Breadcrumbs";
import routes from "routes";
import footerRoutes from "footer.routes";
import DefaultFooter from "components/Footers/DefaultFooter";
import DefaultNavbar from "components/Navbars/DefaultNavbar";
import ReadPDF from "../ReadPDF";

function ResultsCVVP() {
  const pdfFile =
    "https://gyespinoza.github.io/documentsPropertiesSm/Presentación%20de%20Resultados%20Inteligencia%20de%20Negocios%20CHSM%20(1).pdf";

  return (
    <>
      <MKBox variant="gradient" style={{ backgroundColor: "#344767" }} shadow="sm" py={0.25}>
        <DefaultNavbar routes={routes} transparent relative light right />
      </MKBox>
      <MKBox minHeight="25rem" width="100%">
        <MKBox
          color="black"
          variant="gradient"
          p={1}
          position="relative"
          sx={{
            backgroundColor: "#FFF",
            display: "grid",
            placeItems: "Center",
            backgroundSize: "cover",
          }}
        />
        <MKBox component="section" bgColor="white" py={4}>
          <Container>
            <Grid container spacing={1} item xs={12} lg={12} mx="auto">
              <Grid item xs={4}>
                <Breadcrums
                  routes={[
                    { label: "Inicio", route: "/" },
                    { label: "Acerca de", route: "#" },
                    { label: "Hallazgos más importantes", route: "#" },
                    { label: "Resultados de Inteligencia de Negocios CHSM", route: "#" },
                  ]}
                />
              </Grid>
            </Grid>
          </Container>
        </MKBox>
        <MKBox
          component="section"
          position="relative"
          variant="contained"
          sx={{
            display: "grid",
            placeItems: "Center",
            backgroundSize: "cover",
            backgroundColor: "#FFF",
            width: "100%",
          }}
        >
          <Container>
            <Grid container height="100px">
              <MKBox p={1} position="relative">
                <MKTypography variant="h1">
                  Resultados de Inteligencia de Negocios CHSM
                </MKTypography>
              </MKBox>
            </Grid>
            <ReadPDF pdf={pdfFile} name="Resultados de Inteligencia de Negocios CHSM" />
          </Container>
        </MKBox>
      </MKBox>
      <MKBox pt={6} px={1} mt={6}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default ResultsCVVP;
